import { API_READ_TIMEOUT_LONG_MS } from "@finway-group/shared/lib/consts/api.const"
import { OcrResult, ReadFileInvoiceRequest } from "@finway-group/shared/lib/models"
import { ReadFileAiRequest, ReadFileAiResponse } from "@finway-group/shared/lib/models/file/file.api"
import axios from "axios"

export const OcrHttpService = {
    uploadAndRetrieveInvoice: async ({ reqData, abortSignal }: { reqData: ReadFileInvoiceRequest; abortSignal: AbortSignal }) => {
        const { data } = await axios.post<OcrResult>("files/read-invoice", reqData, { signal: abortSignal, timeout: API_READ_TIMEOUT_LONG_MS })
        return data
    },
    uploadAndRetrieveAi: async ({ fileId, reqData, abortSignal }: { fileId: string; reqData: ReadFileAiRequest; abortSignal: AbortSignal }) => {
        const { data } = await axios.post<ReadFileAiResponse>(`files/${fileId}/read-file-ai`, reqData, { signal: abortSignal, timeout: API_READ_TIMEOUT_LONG_MS })
        return data
    },
}
